import { writable } from "svelte/store"

export const debugLoggingEnabled = writable<boolean>(false)
